import axios from '@/http/index';

const base = '';
// 查询会员套餐和项目信息(购买+划扣+充值)
export const selectVipCardItemList = (params) => axios.get(`${base}/erp/lookVipCard/selectVipCardItemList`, params).then((res) => res.data);
// 查看会员套餐
export const getSelectCard = (params) => axios.get(`${base}/erp/lookVipCard/selectClientVipCardList`, params).then((res) => res.data);

/* ---------新版会员套餐套餐接口----------*/
// 获得新增会员跳转链接
export const getMemberUrl = (params) => axios.get(`${base}/erp/member/getMemberUrl`, params).then((res) => res.data);
// 根据会员套餐ID获得提成信息
export const getIdSelectCard = (params) => axios.get(`${base}/erp/lookVipCard/selectVipCardPercentage`, params).then((res) => res.data);
// 查询会员套餐订单记录
export const getBeautyPackageList = (params) => axios.get(`${base}/erp/lookVipCard/getBeautyPackageList`, params).then((res) => res.data);
// 查询美容套餐业务记录
export const getVipCardOrderList = (params) => axios.get(`${base}/erp/lookVipCard/getVipCardOrderList`, params).then((res) => res.data);
// 查询美容套餐业务记录累计总额
export const getVipCardOrderTotal = (params) => axios.get(`${base}/erp/lookVipCard/getVipCardOrderTotal`, params).then((res) => res.data);
// 获得会员卡相关信息
export const getMemberCardMsg = (params) => axios.get(`${base}/erp/member/getMemberCardMsg`, params).then((res) => res.data);
// 获得会员套餐客户信息
export const getUserCardInfo = (params) => axios.get(`${base}/erp/lookVipCard/selectClientVipCardInfo`, params).then((res) => res.data);
// 会员套餐划扣--选择扫码支付
export const postDeductCardCount = (params) => axios.post(`${base}/erp/lookVipCard/updateClientVipCardItem`, params).then((res) => res.data);
// 查询单个会员套餐信息
export const getBeautyPackageOne = (params) => axios.get(`${base}/erp/lookVipCard/getBeautyPackageOne`, params).then((res) => res.data);
// 查询美容套餐用户列表
export const getClientBeautyPackageList = (params) => axios.get(`${base}/erp/lookVipCard/getClientBeautyPackageList`, params).then((res) => res.data);
// 获取会员套餐开单员列表
export const getStaffIdList = (params) => axios.get(`${base}/erp/lookVipCard/technicianList`, params).then((res) => res.data);
// 会员套餐购买--确定支付
export const postCardShopping = (params) => axios.post(`${base}/erp/lookVipCard/gouClientVipCard`, params).then((res) => res.data);
// 会员套餐充值--确定支付
export const postCardPurchase = (params) => axios.post(`${base}/erp/lookVipCard/purchaseClientVipCard`, params).then((res) => res.data);
// 打印订单
export const printOrder = (params) => axios.get(`${base}/erp/print/printOrder`, params).then((res) => res.data);

// （结算）扫码支付--获取订单号
export const getOrderCode = (params) => axios.get(`${base}/erp/payInfo/getOrderCode`, params).then((res) => res.data);
// （结算）扫码支付--获取支付状态
export const getScanPayStatus = (params) => axios.get(`${base}/erp/payInfo/getScanPayStatus`, params).then((res) => res.data);
// （结算）扫码支付--3.6.0
export const newBarCodePay = (params) => axios.get(`${base}/erp/payInfo/barCodePay`, params).then((res) => res.data);
// 获取商家可支付方式：默认支付(0:未设置 2:通联支付,4:微信,5:支付宝,6:(包括支付宝，微信))
export const getPaySet = (params) => axios.get(`${base}/erp/payInfo/getPaySet`, params).then((res) => res.data);
// （4.5.0）获取全局提成设置
export const getPercentageSkin = (params) => axios.get(`${base}/busmanage/lookStoreMain/getPercentageSkin`, params).then((res) => res.data);
// （服务开单或修改订单）根据产品id获得统称列表
export const getTechnicianListByProductId = (params) => axios.get(`${base}/erp/customerOrder/getTechnicianListByProductId`, params).then((res) => res.data);
// （服务开单或修改订单）根据项目id获得统称列表
export const getTechnicianListByItemId = (params) => axios.get(`${base}/erp/customerOrder/getTechnicianListByItemId`, params).then((res) => res.data);
// 获取打印机列表
export const getPrintSetList = (param) => axios.get(`${base}/erp/print/getPrintSetList`, param).then((res) => res.data);

// (4.7.0)获得顾客信息列表
export const getCustomerMsgList = (params) => axios.get(`${base}/erp/customer/getCustomerMsgList`, params).then((res) => res.data);

// （5.4）套餐购买扫码和魔盒支付前提交订单信息
export const toPayBefore4Buy = (params) => axios.post(`${base}/erp/lookVipCard/toPayBefore4Buy`, params).then((res) => res.data);

// （5.4）套餐续费扫码和魔盒支付前提交订单信息
export const toPayBefore4Renew = (params) => axios.post(`${base}/erp/lookVipCard/toPayBefore4Renew`, params).then((res) => res.data);

// (5.4)（结算）获得赊账二维码
export const getQRCode4Credit = (params) => axios.get(`${base}/erp/lookVipCard/getQRCode4Credit`, params).then((res) => res.data);

// 赊账授权非现场授权发送短信
export const sendMsg4Package = (params) => axios.get(`${base}/erp/lookVipCard/sendMsg4Package`, params).then((res) => res.data);
// （魔盒）获得魔盒列表
export const getMagicBoxList = (params) => axios.get(`${base}/erp/customerOrder/getMagicBoxList`, params).then((res) => res.data);
// （结算）扫码支付
export const barCodePay = (params) => axios.get(`${base}/erp/customerOrder/barCodePay`, params).then((res) => res.data);
// （魔盒）魔盒订单推送
export const receptionOrder = (params) => axios.get(`${base}/erp/lookVipCard/receptionOrder`, params).then((res) => res.data);
// （结算）扫码支付--获取支付状态
export const newGetScanPayStatus = (params) => axios.get(`${base}/erp/payInfo/getScanPayStatus`, params).then((res) => res.data);

// (3.8.0)获得店铺结算设置信息
export const getPayCodeList = (params) => axios.get(`${base}/erp/payInfo/getPayTypeSetList`, params).then((res) => res.data);

// (5.4)查询套餐部分支付还款页面信息
export const getPackagePartPayMsg = (params) => axios.get(`${base}/erp/lookVipCard/getPackagePartPayMsg`, params).then((res) => res.data);

// 5.7erp选择统称，选择销售的轮牌列表
export const erpTechnicianCardByMainId = (params) => axios.get(`${base}/erp/lookTechnicianCard/erpTechnicianCardByMainId`, params).then((res) => res.data);

// 5.7（服务开单或修改订单）根据项目、产品、套餐id获取统称-员工列表
export const getStaffBrandList = (params) => axios.get(`${base}/erp/lookTechnicianCard/getTechnicianListByItemId`, params).then((res) => res.data);

// (6.1.0)查询某个顾客某个套餐的套餐购买订单列表
export const getOneClientVipCardOrderList = (params) => axios.get(`${base}/erp/lookVipCard/getOneClientVipCardOrderList`, params).then((res) => res.data);

// (4.1订单详情)获得服务开单订单详情
export const getOrderDetail4AllDto = (param) => axios.get(`${base}/erp/customerOrder/getOrderDetail4AllDto`, param).then((res) => res.data);

// (6.1)修改顾客套餐过期时间
export const saveClientPackagePastTime = (param) => axios.get(`${base}/erp/lookVipCard/saveClientPackagePastTime`, param).then((res) => res.data);
// (6.1)查询顾客套餐修改详情列表
export const getClientPastTimeModifyList = (param) => axios.get(`${base}/erp/lookVipCard/getClientPastTimeModifyList`, param).then((res) => res.data);
// (6.2)获得顾客信息列表
export const getSimpleCustomerMsgListPage = (params) => axios.post(`${base}/erp/customer/getSimpleCustomerMsgListPage`, params).then((res) => res.data);

// （魔盒）魔盒订单推送
export const payQrOrderPush = (params) => axios.post(`${base}/erp/payInfo/payQrOrderPush`, params).then((res) => res.data);

// (6.2)取消smartBox推送
export const cancelSmartBoxPush = (params) => axios.get(`${base}/erp/payInfo/cancelSmartBoxPush`, params).then((res) => res.data);

// （6.7）获取会员可划扣列表(含套餐+电子票)
export const getDeductList = (params) => axios.get(`${base}/erp/customerOrder/getDeductList`, params).then((res) => res.data);

// （6.7）(6.7)获取会员可划扣详情
export const getDeductDetails = (params) => axios.get(`${base}/erp/customerOrder/getDeductDetails`, params).then((res) => res.data);
